<template>
  <div class="orderContent">
    <navBar :title="topTitle"></navBar>
    <div class="orderInfo box">
      <div class="title">取包裹地址</div>
      <div class="telBox flexBetween">
        <div class="left">
          <div class="address">{{orderInfo.express_address?orderInfo.market_name +
            orderInfo.express_address.building_room:''}}
          </div>
          <div class="info">{{orderInfo.express_address?orderInfo.account_name + ' ' +
            orderInfo.express_address.mobile:''}}
          </div>
        </div>
        <div class="phone" @click="contactUser"></div>
      </div>
    </div>
    <div class="box" v-if="statusId==20">
      <div class="flexBetween moneyInfo">
        <div class="name">预收款</div>
<!--        <div class="rValue">￥{{orderInfo.amount}}</div>-->
        <van-field v-model="orderInfo.amount==0?'':orderInfo.amount" placeholder="请输入预收款" type="number" />
      </div>
      <div class="flexBetween moneyInfo">
        <div class="name">收款方式</div>
        <div class="value" @click="pickShow = true">{{orderInfo.pay_code?orderInfo.pay_code:'请选择收款方式'}}</div>
        <van-overlay :show="pickShow" @click="pickShow = false">
          <van-picker show-toolbar
                      visible-item-count="3"
                      title="收款方式"
                      :columns="columns"
                      @cancel="pickerCancel"
                      @confirm="pickerConfirm" />
        </van-overlay>
      </div>
    </div>
    <div class="orderInfo box">
      <div class="title">订单信息</div>
      <div class="infoCont">
        <div class="orderSn flexBetween">
          <div class="name">订单号</div>
          <div class="value">{{orderInfo.market_express_sn}}
            <span v-clipboard:copy="orderInfo.market_express_sn" v-clipboard:success="copySuc"
                  v-clipboard:error="copyFail">复制</span></div>
        </div>
        <div class="orderTime flexBetween">
          <div class="name">下单时间</div>
          <div class="value">{{orderInfo.create_time}}</div>
        </div>
      </div>
    </div>
    <!--代配送订单流程-->
    <div class="box" v-if="statusId!=10" style="position:relative;margin-bottom: 40px;">
      <van-steps direction="vertical" active="10" active-color="#8D95A6">
        <van-step v-for="(sItem,sIndex) in orderInfo.express_log" :key="sIndex">
          <div class="flexBetween">
            <b class="title">{{sItem.content}}</b>
            <p class="time">{{sItem.opeate_time}}</p>
          </div>
        </van-step>
      </van-steps>
      <div class="failInfo" v-if="statusId==1" style="position:absolute;top: 30px;left: 50px;color: #DE1919;font-weight: bold;">失败原因：{{orderInfo.comment}}</div>
    </div>

    <van-button type="primary" block @click="sureOrder"
                :loading="loading"
                loading-type="circular"
                :disabled="isDisable"
                :loading-text="buttonText" v-if="statusId==10||statusId==20">{{buttonText}}
    </van-button>

  </div>
</template>

<script>
  import navBar from "../../components/navBar";
  import Vue from 'vue';
  import {Toast, Button, Loading, Step, Steps,Dialog,Picker,Overlay,Field} from 'vant';

  Vue.use(Toast).use(Button).use(Loading).use(Step).use(Steps).use(Dialog).use(Picker).use(Overlay).use(Field);
  export default {
    name: "orderContent",
    components: {
      navBar
    },
    data() {
      return {
        isDisable:false,
        columns:['微信','支付宝','线下支付'],//收款方式
        topTitle: '',
        loading: false,//按钮加载
        orderInfo: {},
        orderId: this.$route.query.id,
        statusId: this.$route.query.status,
        buttonText: '',
        pickShow:false//收款方式选择
      }
    },
    mounted() {
      this.getTopTitle();
      this.getOrderInfo();
    },
    methods: {
      //选择收款方式
      pickerConfirm(val){
        this.pickShow = false;
        this.orderInfo.pay_code = val;
      },
      //picker取消
      pickerCancel(){
        this.pickShow = false;
      },
      //拨打电话
      contactUser(){
        Dialog.confirm({
          message: this.orderInfo.express_address.mobile,
          confirmButtonText:'呼叫'
        }).then(() => {
          window.location.href = `tel:${this.orderInfo.express_address.mobile}`;
        }).catch(() => {
          // on cancel
        });

      },
      //订单提交
      sureOrder() {
        let statusId = this.statusId;
        this.isDisable = true;
        //待确认提交
        if (this.orderId && statusId == '10') {
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressdelivery/confirm`,
            data: {
              market_express_id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            this.isDisable = false;
            if (res.code == '0') {
              this.$router.push('/jjOrder');
            }
            Toast(res.msg);
          })
        }

        //寄件完成提交
        if (this.orderId && statusId == '20') {
          let payString = this.orderInfo.pay_code;
          let pay_code = '';
          if(payString){
            if(payString=='微信'){
              pay_code = 'weixin';
            }else if(payString=='支付宝'){
              pay_code = 'alipay';
            }else if(payString=='线下支付'){
              pay_code = 'offline';
            }else{
              return false
            }

          }else{
            Toast('请选择收款方式');
            return false
          }
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressdelivery/finish`,
            data: {
              market_express_id: this.orderId,
              amount:this.orderInfo.amount,
              pay_code:pay_code
            }
          }).then(res => {
            this.loading = false;
            this.isDisable = false;
            if (res.code == '0') {
              this.$router.push('/jjOrder');
            }
            Toast(res.msg);
          })
        }


      },
      //获取头部标题
      getTopTitle() {
        let statusId = this.$route.query.status;
        if (statusId == 0) {
          this.topTitle = '寄件-已取消';
        }
        if (statusId == 10) {
          this.topTitle = '寄件-待领取';
          this.buttonText = '确认领取';
        }
        if (statusId == 20) {
          this.topTitle = '寄件-待寄件';
          this.buttonText = '寄件完成';
        }
        if (statusId == 50) {
          this.topTitle = '寄件-已完成';
        }
      },
      //获取当前订单详情
      getOrderInfo() {
        if (this.orderId) {
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressdelivery/detail`,
            data: {
              market_express_id: this.orderId
            }
          }).then(res => {
            console.log(res)
            this.orderInfo = res.data;
          })
        }
      },
      copySuc() {
        Toast('复制成功');
      },
      copyFail() {
        Toast('复制失败');
      }
    }
  }
</script>

<style scoped lang="less">
  .van-cell{
    width: 25%;
    padding: 0;
  }
  .van-overlay{
    display: flex;
    align-items: flex-end;
    z-index:100;
  }
  .van-picker{
    width: 100%;
  }
  .btnGroup{
    margin: 20px 0;
    .van-button--block{
      width: 347px;
      margin: 20px auto;
      border: none;
      font-size: 16px;
    }
  }
  .expressImg{
    height: 88px;
    .imgBox{
      width: 70px;
      height: 70px;
      overflow: hidden;
      margin: 10px 0;
      margin-right: 16px;
      img{
        width: 100%;
      }
    }
  }
  .expressContent{
    padding: 6px 0;
    line-height: 24px;
  }
  .van-button--primary {
    background-color: #687BFF;
    border: none;
    font-size: 16px;
    width: 347px;
    margin: 80px auto;
    height: 48px;
    line-height: 48px;
  }

  .orderContent {
    background: #f5f5f5;
    position: absolute;
    width: 100%;
    min-height: 100%;

    .box {
      background: #fff;
      margin-top: 6px;
      padding: 0 14px;
      .moneyInfo{
        line-height: 44px;
        .rValue{
          color: #DE1919;
        }
      }
      .moneyInfo:first-child{
        border-bottom: 1px solid #F5f5f5;
      }
      .left {
        padding: 12px 0;

        .info {
          color: #8D95A6;
          font-size: 13px;
          line-height: 30px;
        }
      }

      .phone {
        width: 17px;
        height: 17px;
        background: url("../../assets/images/phone.png") no-repeat;
        background-size: contain;
      }
    }

    .orderInfo {
      .title {
        line-height: 44px;
        border-bottom: 1px solid #F5f5f5;
        font-weight: bold;
      }

      .infoCont {
        line-height: 26px;
        padding: 10px 0;

        .name {
          color: #8D95A6;
        }

        .value {
          span {
            padding-left: 10px;
            color: #687BFF;
            text-decoration: underline;
          }
        }
      }

    }

    .orderitem {
      line-height: 40px;
      font-size: 14px;

      .bPrice {
        color: #687BFF;
      }

      .rPrice {
        color: #DE1919;
      }
    }
  }

</style>
<style>
  .van-field__control{
    text-align: right;
    color: #DE1919;
  }
  .van-picker-column__item{
    color: #687BFF;
  }
  .van-picker__title{
    font-size: 18px;
  }
  .van-step--finish .van-step__circle, .van-step--finish .van-step__line {
    background: #8D95A6 !important;
  }
</style>
